// extracted by mini-css-extract-plugin
export default {"imageWrapper":"oH-z","twoColumnImage":"pH-z"};